// Curated thin/modern sans-serif Google Fonts for tenant white-labeling.
// Each entry: family name (matches Google Fonts), human label, weights to load,
// and a one-line aesthetic descriptor shown in the picker.
export const TENANT_FONTS = [
  { family: "Inter",              label: "Inter",              weights: "300;400;500;700", desc: "Clean, technical, neutral" },
  { family: "Manrope",            label: "Manrope",            weights: "300;400;500;700", desc: "Friendly geometric — our default" },
  { family: "Outfit",             label: "Outfit",             weights: "300;400;500;700", desc: "Soft, rounded, premium" },
  { family: "Poppins",            label: "Poppins",            weights: "300;400;500;700", desc: "Geometric, lively, India-friendly" },
  { family: "Quicksand",          label: "Quicksand",          weights: "300;400;500;700", desc: "Rounded, casual, approachable" },
  { family: "DM Sans",            label: "DM Sans",            weights: "300;400;500;700", desc: "Low-contrast, editorial" },
  { family: "Plus Jakarta Sans",  label: "Plus Jakarta Sans",  weights: "300;400;500;700", desc: "Modern, balanced, premium" },
];

// Dynamically inject a Google Fonts <link> tag for a given family (idempotent).
export function ensureGoogleFont(family, weights = "300;400;500;700") {
  if (!family) return;
  const id = `gf-${family.replace(/\s+/g, "-").toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  const fam = family.replace(/\s+/g, "+");
  link.href = `https://fonts.googleapis.com/css2?family=${fam}:wght@${weights}&display=swap`;
  document.head.appendChild(link);
}
